import store from 'store';
import DateFilter from '../../../components/grid/filters/DateFilter';
import { DATASET_LNG } from '_legacy/models/Datasets';

export class ReportedDateFilter extends DateFilter {
    constructor(props) {
        super(props);
        const userDataset = store.getState().user.group?.datasetId;
        this.useQuarters = userDataset === DATASET_LNG;
    }
}
